import { CommonActions } from '@react-navigation/native'
import { BottomSheet } from '@zet/common/components/bottomSheet'
import { Button, H4, SH3, Stack } from '@zet/design-system'
import useAuthStore from '@zet/feature-user/store/authStore'
import { i18n } from '@zet/localization'
import { navigationRef } from '@zet/utils/navigation'
import storageUtil from '@zet/utils/storage'

import IdCard from '../assets/svg/idCard.svg'

type ICompleteProfile = {
  isVisible: boolean
  setIsVisible: (x: boolean) => void
}
export function CompleteProfile({ isVisible, setIsVisible }: ICompleteProfile) {
  const { setIsAuthenticated, setAuthToken } = useAuthStore((store) => store)
  const handlePress = () => {
    setAuthToken('')
    storageUtil.mmkvStorage.clearAll()
    setIsAuthenticated(false)
    navigationRef.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: 'VerifyPhone' }],
      })
    )
    setIsVisible(false)
  }
  return (
    <BottomSheet
      visible={isVisible}
      disableBottomSheet={() => setIsVisible(false)}
      sheetName={'complete_existing_profile'}
    >
      <Stack className="items-center p-0">
        <IdCard className="mt-5" />
        <H4 className="mt-3 px-3 text-center">
          {i18n.t('lowIntentTask.completeRegistration')}
        </H4>
        <SH3 className="text-grays-60 mt-2 px-3 text-center">
          {i18n.t('lowIntentTask.enterBasicDetails')}
        </SH3>
        <Stack className="border-grays-40 m-3 w-full border-t px-3 pt-3">
          <Button fullWidth onPress={handlePress} size={'lg'}>
            {i18n.t('lowIntentTask.createProfile')}
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  )
}
